import React, { useState, useEffect } from 'react';
import '../../../entrydoor.css';
import ImageModal from '../../../components/ImageModal';

const OptionS = ({
  value,
  onChange,
  label = 'Option * :',
  disabled = false,
  showPics = false,
}) => {
  const defaultColor = {
    value: value?.value || '#F8F8FF',
    label: value?.label || 'Clear',
  };

  const [selectedOptionS, setSelectedOptionS] = useState(defaultColor);
  const [showModal, setShowModal] = useState(false);

  const handleOptionSChange = (e) => {
    const newValue = e.target.value;
    const selectedText = e.target.options[e.target.selectedIndex].text;

    const newOption = { value: newValue, label: selectedText };
    setSelectedOptionS(newOption);
    onChange(newOption);
  };

  // Fire initial onChange once
  useEffect(() => {
    onChange(defaultColor);
  }, []);

  return (
    <div className="a-container">
      <label htmlFor="OptionS" disabled={disabled}>
          {label}
          {showPics && (
              <span
                  onClick={() => setShowModal(true)}
                  style={{
                      display: 'inline-block',
                      marginLeft: '6px',
                      width: '16px',
                      height: '16px',
                      borderRadius: '50%',
                      backgroundColor: '#007bff',
                      color: '#fff',
                      textAlign: 'center',
                      lineHeight: '16px',
                      fontSize: '12px',
                      cursor: 'pointer',
                      userSelect: 'none'
                  }}
                  title="Click to view image"
              >
                  i
              </span>
          )}
      </label>

      <select
        disabled={disabled}
        id="OptionS"
        value={selectedOptionS.value}
        onChange={handleOptionSChange}
      >
        <option value="#F8F8FF">
          {selectedOptionS.value === '#F8F8FF' ? 'Clear ✔' : 'Clear'}
        </option>
        <option value="#DCDCDC">
          {selectedOptionS.value === '#DCDCDC' ? 'Sandblasted ✔' : 'Sandblasted'}
        </option>
        <option value="#E0E0E0">
          {selectedOptionS.value === '#E0E0E0' ? 'Delta ✔' : 'Delta'}
        </option>
      </select>

      <ImageModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        folder="images/textures"
        imageName={selectedOptionS.label} // ✅ Now works!
        //width={400}
        //height={400}
      />
    </div>
  );
};

export default OptionS;
